import React from 'react'
import history from 'browserHistory'
import RoutesHelper from 'helpers/RoutesHelper'
import { Button } from 'components/base'
import EmptyStateImage from './empty-state.svg'

class EmptyState extends React.PureComponent {
  handleAddIntegrationClick = event => {
    event.preventDefault()
    history.push(RoutesHelper.settingsIntegrationListApplications())
  }

  render() {
    return (
      <div className="flexbox flexbox-column flexbox-align-center">
        <img
          src={EmptyStateImage}
          width={310}
          alt="Empty state logo"
          style={{ marginTop: 100 }}
        />
        <div className="margin-top-large">
          <p className="shade-10">You haven't integrated with any apps yet.</p>
        </div>
        <Button.Primary
          className="margin-top-large"
          onClick={this.handleAddIntegrationClick}
        >
          Add Integrations
        </Button.Primary>
      </div>
    )
  }
}

export default EmptyState
